import { render, staticRenderFns } from "./Species.vue?vue&type=template&id=e23cd496&scoped=true&slot-scope=scope&"
import script from "./Species.vue?vue&type=script&lang=js&"
export * from "./Species.vue?vue&type=script&lang=js&"
import style0 from "./Species.vue?vue&type=style&index=0&id=e23cd496&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23cd496",
  null
  
)

export default component.exports